<template>
    <footer class="copyright">
        <div class="cabinet-footer">
            <div class="flex flex-column flex-md-row">
                <a href="/partners" class="copyright__link">Партнерам</a>
                <a
                    href="https://docs.goldnet.market/doku.php?id=user_agreement"
                    target="_blank"
                    class="copyright__link"
                    >Пользовательское соглашение</a
                >
                <a
                    href="https://docs.goldnet.market/doku.php?id=privacy_policy"
                    target="_blank"
                    class="copyright__link"
                    >Конфиденциальность</a
                >
                <a href="mailto:info@goldnet.market" class="copyright__link"
                    >Связаться с нами</a
                >
                <div class="copyright__text">
                    © {{ new Date().getFullYear() }} {{ appName }}
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import settings from '@/settings.js'

export default {
    name: 'CabinetFooter',
    data() {
        return {
            appName: settings.APP_NAME
        }
    }
}
</script>
